import { adminAccessService } from '../api/adminAccessService';
import { useAdminAccess } from '@/shared/model/adminAccess';

/** Обновляет возможности текущей административной сессии */
export const refreshAdminAccess = async (): Promise<void> => {
    const state = useAdminAccess.getState();
    const revision = state.begin();

    try {
        const snapshot = await adminAccessService.getCurrent();

        state.complete(revision, snapshot);
    } catch (error: unknown) {
        state.fail(revision, error instanceof Error
            ? error.message
            : 'Не удалось загрузить права доступа');
    }
};
